import React from "react";
import Layout from "../components/Layout";
import MesReunions from "../components/Employé/MesReunions";

function MesReunion() {
  
  return (
    <Layout >
      <div className="p-6">
        <MesReunions />
      </div>
    </Layout>
  );
}

export default MesReunion;
